<template>
    <div v-if="itemXDocEditData != null">
        <v-form ref="itemDocEditform" v-model="itemDocEditFormValid" lazy-validation>

            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12 v-show="!isNew">
                        <v-select
                        :rules="isNew?[]:[rules.required]"
                        label="Doc. Category"
                        v-bind:items="docCategories"
                        v-model="itemXDocEditData.docCategoryId"
                        item-text="name"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                    <v-flex xs12 v-show="!isNew">
                        <v-select
                        :rules="isNew?[]:[rules.required]"
                        label="Doc"
                        v-bind:items="docs"
                        v-model="itemXDocEditData.docId"
                        item-text="docName"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                    <v-flex xs12 v-show="isNew">
                        <v-text-field 
                            :rules="isNew? [rules.required] : []"
                            v-model="itemXDocEditData.url" 
                            label="Url"
                            hint="Url MUST be a Document Url setup already!!"
                            persistent-hint
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12>
                        <v-text-field 
                            v-model="itemXDocEditData.atPage" 
                            label="Page #"
                            ></v-text-field>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="white hide">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="save()">
                    Submit
                    </v-btn>
                    <v-btn class="info" @click="cancel()">
                    Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- {{itemXDocEditData}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: ['itemXDocEditData'],
    data () {
        return {
            // itemXDocEditData: {},
            docCategories: [
                // {id: 'brochure', name: 'Brochure'},
                // {id: 'priceList', name: 'Price List'},
                // {id: 'ifu', name: 'IFU'},
                // {id: 'memo', name: 'Memo'},
                // {id: 'sds', name: 'SDS'},
                {id: 'productUrl', name: 'ProductUrl'},
            ],
            docs: [
            ],
            itemDocEditFormValid: true,
            rules: {
                required: v => !!v || "This field is required"
            },

        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return !this.itemXDocEditData.id
        },
        title () {
            return this.isNew?'Assign Document' : 'Edit Assigned Document'
        }
    },
    methods: {
        ...mapActions('adminItemProdDb', [
            'getItmDocs'
        ]),
        async getDocs() {
            this.docs = await this.getItmDocs(this.itemXDocEditData.docCategoryId)
        },
        ...mapActions('adminItemProdDb', [
            // 'populateRegionEditModel',
            'saveItemXDoc'
        ]),
        async save() {
            if (this.$refs.itemDocEditform.validate()) {
                var result = await this.saveItemXDoc(this.itemXDocEditData)
                if(result != 'successful') {
                    alert('The doc url does not exists in predefined Document. Please setup document first!')
                }
                else {
                    this.$emit('onCloseItemXDocEditData')

                }
            }
            // this.$router.push({name: 'admin-regions'})
        },
        cancel() {
            // this causes data reload, even it is not necessary
            this.$emit('onCloseItemXDocEditData')

            // this.$router.push({name: 'admin-regions'})
        },
    },
    watch: {
        'itemXDocEditData.docCategoryId': {
            handler: async function (newValue, oldValue) {
                // console.log('ddd')
                // this.docs = await this.populateRegionEditModel(newValue)
                // if(newValue != oldValue) {
                //     // console.log(newValue + ' - ' + oldValue)
                // }
                if(newValue){
                    this.getDocs()
                }
                else {
                    this.docs = []
                }
            },
            //deep: true
        }
    },
    async created () {
    }
}
</script>
